import { TParchiSaTemplate } from "@elixir/types";
import { GET_HUB_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function getSaTemplate({
  doctorOid,
  authToken,
}: {
  doctorOid: string;
  authToken?: string;
}): Promise<{
  status: string;
  success: boolean;
  template?: Array<TParchiSaTemplate>;
  message?: string;
}> {
  try {
    const HUB_HOST = GET_HUB_HOST();
    let endpoint = `${HUB_HOST}/account/self-assessment/?docId=${doctorOid}`;
    const res = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(authToken && { auth: authToken }),
      },
    });

    const json = await res.json();

    if (Array.isArray(json)) {
      return {
        status: "success",
        success: true,
        template: json as Array<TParchiSaTemplate>,
      };
    }

    return {
      status: json?.status ?? "error",
      success: false,
      template: [],
      message: json?.message ?? json?.error,
    };
  } catch (e) {
    return {
      status: "error",
      success: false,
      template: [],
      message: "Failed to load SA templates",
    };
  }
}
